import { render, staticRenderFns } from "./LinkCadastros.vue?vue&type=template&id=bdf73be0&"
import script from "./LinkCadastros.vue?vue&type=script&lang=js&"
export * from "./LinkCadastros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports